<div class="container-fluid">
  <div
    class="account-header d-flex justify-content-between bg-white align-items-center mt-4 p-2"
  >
    <div class="d-flex align-items-center p-2">
      <button
        mat-button
        class="back-icon text-muted me-2 mat-elevation-z8"
        (click)="goToAccountingPage()"
      >
        <mat-icon class="back-mat-icon">keyboard_backspace</mat-icon>
      </button>
      <h4 class="text-muted mb-0">
        Import Account {{ accountData?.firstName }} - Handyman
      </h4>
      <span
        [ngClass]="
          status === 'Imported'
            ? 'imported-status'
            : status === 'Error'
              ? 'error-status'
              : 'default-status'
        "
      >
        @if (status === "Imported") {
          <img src="../../../../../assets/icons/Imported.png" alt="" />
        }
        @if (status === "Error") {
          <img src="../../../../../assets/icons/Failed.png" alt="" />
        }
        @if (status === "Open") {
          <img width="50px" src="../../../../../assets/icons/Open.png" alt="" />
        }
      </span>
    </div>

    @if (!isAccountDetailsEditable) {
      <div class="col d-flex justify-content-end m-3">
        <button
          class="btn text-white"
          mat-raised-button
          class="edit-icon"
          (click)="editAccountDetails()"
        >
          <img
            src="../../../../../assets/icons/Edit.png"
            alt="edit icon"
            class="edit-icon"
            width="15"
            height="15"
          />
          <b class="pl-1">Edit</b>
        </button>
      </div>
    } @else if (isAccountDetailsEditable) {
      <div
        class="col d-flex justify-content-end align-self-end account-buttons m-3"
      >
        <button
          class="btn text-white bg-success"
          mat-raised-button
          (click)="saveAccountDetails()"
        >
          Save <mat-icon>save</mat-icon>
        </button>
        <button
          class="btn text-white bg-secondary"
          mat-raised-button
          (click)="cancelEditAccountDetails()"
        >
          Cancel <mat-icon>cancel</mat-icon>
        </button>
      </div>
    }
  </div>
  <div class="container-fluid bg-white pe-3 px-3 pb-0">
    <h5 class="pt-1 px-3">Data</h5>

    @if (!isAccountDetailsEditable) {
      <div class="row pe-3 px-3 pb-0">
        <div class="col">
          <p class="h6">
            Name:
            <span class="text-muted"
              >{{ accountData?.firstName }} {{ accountData?.surName }}</span
            >
          </p>
          <p class="h6">
            Profile ID:
            <span class="text-muted">{{ accountData?.profileId }}</span>
          </p>

          <p class="h6">
            Type:
            <span class="text-muted">{{
              isClient ? "Klant" : "Handyman"
            }}</span>
          </p>
          <p class="h6">
            Creation Date:
            <span class="text-muted">{{ creationDate }}</span>
          </p>
        </div>
        <div class="col">
          <p class="h6">
            Phone Number:
            <span class="text-muted">{{ accountData?.phone }}</span>
          </p>
          <p class="h6">
            Email: <span class="text-muted">{{ accountData?.email }}</span>
          </p>
          <p class="h6">
            Address:
            <span class="text-muted"
              >{{ accountData?.houseNumber }} -
              {{ accountData?.houseNumberAdd }} - {{ accountData?.address }} -
              {{ accountData?.postCode }}</span
            >
          </p>
        </div>
        <div class="col">
          <p class="h6">
            Bank Name:
            <span class="text-muted">{{ accountData?.bankName }}</span>
          </p>
          <p class="h6">
            IBAN: <span class="text-muted">{{ accountData?.iban }}</span>
          </p>
          <p class="h6">
            ExactOnline ID:
            <span class="text-muted">{{ accountData?.exactOnlineID }}</span>
          </p>
        </div>
      </div>
    } @else {
      <div class="row">
        <div>
          <form [formGroup]="accountForm" class="dialog-form">
            <div class="row">
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>First Name</mat-label>
                  <input
                    matInput
                    formControlName="firstName"
                    required
                    aria-label="firstName"
                    title="First Name"
                  />
                  @if (accountForm.get("firstName")?.hasError("required")) {
                    <mat-error> First Name is required. </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Sur Name</mat-label>
                  <input
                    matInput
                    formControlName="surName"
                    required
                    aria-label="Sur Name"
                    title="Sur Name"
                  />
                  @if (accountForm.get("surName")?.hasError("required")) {
                    <mat-error> Sur Name is required. </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Phone Number</mat-label>
                  <input
                    matInput
                    formControlName="phone"
                    aria-label="Phone"
                    title="Phone"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Email</mat-label>
                  <input
                    matInput
                    formControlName="email"
                    required
                    aria-label="Email"
                    title="Email"
                  />
                  @if (accountForm.get("email")?.hasError("required")) {
                    <mat-error> Email is required. </mat-error>
                  }
                  @if (accountForm.get("email")?.hasError("email")) {
                    <mat-error> Enter a valid email. </mat-error>
                  }
                </mat-form-field>
              </div>

              <!-- <div class="row"> -->
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>House Number</mat-label>
                  <input
                    matInput
                    formControlName="houseNumber"
                    aria-label="House Number"
                    title="House Number"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Address</mat-label>
                  <input
                    matInput
                    formControlName="address"
                    aria-label="Address"
                    title="Address"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Address Line 1</mat-label>
                  <input
                    matInput
                    formControlName="houseNumberAdd"
                    aria-label="Address Line 1"
                    title="Address Line 1"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>City</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    title="City"
                    aria-label="City"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Post Code</mat-label>
                  <input
                    matInput
                    formControlName="postCode"
                    aria-label="Postcode"
                    title="Postcode"
                  />
                </mat-form-field>
              </div>
              <!-- </div> -->
              <!-- <div class="row"> -->
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Type</mat-label>
                  <input
                    matInput
                    formControlName="isClient"
                    title="Client/Handyman"
                    aria-label="Client/Handyman"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Bank Name</mat-label>
                  <input
                    matInput
                    formControlName="bankName"
                    title="Bankname"
                    aria-label="Bankname"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>Bank Account</mat-label>
                  <input
                    matInput
                    formControlName="iban"
                    title="Iban"
                    aria-label="Iban"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width" readOnly>
                  <mat-label>Creation Date</mat-label>
                  <input
                    matInput
                    formControlName="creationDate"
                    title="Created Date"
                    aria-label="Created Date"
                  />
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field class="full-width">
                  <mat-label>ExactOnline ID</mat-label>
                  <input
                    matInput
                    formControlName="exactOnlineID"
                    disable="true"
                    aria-label="ExactOnlineId"
                    title="ExactOnlineId"
                  />
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </div>
    }

    <div class="container-fluid table-wrapper">
      <section class="example-container bg-white p-2 table-layout-content" tabindex="0">
        <div class="logs-container">
          <h5 class="pt-3">
            {{ showLogForm ? "Update Logs" : "Activity & Log" }}
          </h5>
          <div class="col d-flex justify-content-end m-3">
            <button
              class="btn text-white bg-success"
              mat-raised-button
              (click)="updateLogs()"
            >
              {{ showLogForm ? "Show Logs" : "Update Logs" }}
              @if (!showLogForm) {
                <mat-icon>add</mat-icon>
              }
            </button>
          </div>
        </div>

        @if (!showLogForm) {
          <div class="table-container-scroll">
            <section class="table-scroll-region" tabindex="0">
              <table
                mat-table
                [dataSource]="dataSource"
                matSortActive="date"
                matSortDisableClear
                matSortDirection="desc"
                class="bg-white"
              >
                <!-- Name Column -->
                <ng-container matColumnDef="date" sticky>
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="modern-table-header-row"
                  >
                    Date
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.creationDateString }}
                  </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name" sticky>
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="modern-table-header-row"
                  >
                    Name
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>

                <!-- Position Column -->
                <!-- <ng-container matColumnDef="comment">
                                                <th mat-header-cell *matHeaderCellDef class="modern-table-header-row">
                                                  Description
                                                </th>
                                                <td mat-cell *matCellDef="let element">{{ element.description }}</td>
                                              </ng-container> -->

                <!-- Weight Column -->
                <ng-container
                  matColumnDef="description"
                  class="modern-table-header-row"
                >
                  <th mat-header-cell *matHeaderCellDef>Comment</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.description }}
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </section>
          </div>

          <mat-paginator
            class="bg-white table-pagination-fixed"
            [pageSizeOptions]="[5, 10, 20, 50]"
            [length]="totalRecords"
            [pageSize]="currentPageSize"
            [pageIndex]="currentPageIndex"
            (page)="handlePageEvent($event)"
            aria-label="Select page of invoice logs"
          >
          </mat-paginator>
        } @else if (showLogForm) {
          <section class="example-container" tabindex="0">
            <app-logs (logData)="getLogData($event)"></app-logs>
          </section>
        }
      </section>
    </div>
  </div>
</div>
